export function isLoggedIn() {
  const authToken = localStorage.getItem("AUTH_TOKEN");
  return authToken && authToken.length > 0;
}
